import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'referenceAreaListLatLng'
})
export class ReferenceAreaListLatLngPipe implements PipeTransform {

  transform(positions: any[]): string {
    return positions.reduce((acc, pos) => {
      return acc ? acc + " " + pos.latitude + "," + pos.longitude : pos.latitude + "," + pos.longitude
      }, "");
  }

}
